import { apiClient } from '@/api/core';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import { mapUpdatedSecurityGroupingToModel } from '../mappers';
import type {
  LC_UpdateSecurityGroupingOut,
  UpdateSecurityGroupingRequest,
  UpdateSecurityGroupingResult,
} from '../types';


export class SecurityGroupingUpdateService {
  async update(
    id: number,
    payload: UpdateSecurityGroupingRequest,
  ): Promise<ApiResponse<UpdateSecurityGroupingResult>> {
    const response = await apiClient.patch<LC_UpdateSecurityGroupingOut>(
      API_CONFIG.ENDPOINTS.SECURITY_GROUPING.UPDATE(id),
      {
        code: payload.code,
        groupName: payload.groupName,
        sendsAttendanceStatus: payload.sendsAttendanceStatus,
      },
    );

    if (response.success && response.data) {
      return { ...response, data: mapUpdatedSecurityGroupingToModel(response.data) };
    }

    return { ...response, data: null };
  }
}

export const securityGroupingUpdateService = new SecurityGroupingUpdateService();
